import { Step4Error, Step4Pending, Step4Success } from '@/Contract/ui/atoms'
import { useBankAccount } from '@/Contract/ui/context'
import { LogaltyResponseStatus } from '@/Logalty/domain'
import { LogaltyStatusChecker } from '@/Logalty/ui/organisms'

const renderState = (state: LogaltyResponseStatus): JSX.Element => {
  switch (state) {
    case LogaltyResponseStatus.Pending:
      return <Step4Pending />
    case LogaltyResponseStatus.Success:
      return <Step4Success />
    case LogaltyResponseStatus.Error:
      return <Step4Error />
    default:
      return <Step4Pending />
  }
}

export const ChangeBankAccountStep4 = (): JSX.Element => {
  const { logalty, confirmationForm } = useBankAccount()
  const { getSignStatus, signStatus } = logalty

  return (
    <LogaltyStatusChecker
      logalty={logalty}
      currentModel={''}
      getSignStatus={() => getSignStatus(confirmationForm.getValues())}
    >
      {renderState(signStatus)}
    </LogaltyStatusChecker>
  )
}
